import * as Yup from "yup";
export const generalErrorMessage = "Field is required";
export const atLeastOneField = "At least one option must be selected";
export const validationSchema = Yup.object({
  multicurrency_card_offer_multicurrency: Yup.string().required(generalErrorMessage),
  multicurrency_card_supported_currency: Yup.array(Yup.string()).when("multicurrency_card_offer_multicurrency", {
    is: (value) => value && value === "Yes",
    then: () => Yup.array(Yup.string()).required(generalErrorMessage),
    otherwise: () => Yup.array().optional(),
  }),
  multicurrency_card_main_currency: Yup.string().required(generalErrorMessage)

});
